"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyCommandBase = void 0;
var JourneyCommandBase = /** @class */ (function () {
    function JourneyCommandBase() {
    }
    JourneyCommandBase.prototype.getSetting = function (setting, settings) {
        if (!settings) {
            return undefined;
        }
        return settings[setting];
    };
    return JourneyCommandBase;
}());
exports.JourneyCommandBase = JourneyCommandBase;
//# sourceMappingURL=JourneyCommandBase.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/commands/JourneyCommandBase.js
// module id = 97
// module chunks = 0